import React from "react";
import './_static/Buttons.css';

function UnpackButton(props) {
    return (
        <button type="button" className="btn btn-outline-info btn-sm unpackButton bigButton" style={{"opacity": "0.8"}} onClick={props.onClick}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                 className="bi bi-three-dots buttonImage" viewBox="0 0 16 16">
                <path
                    d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/>
            </svg>Detaily
        </button>
    )
}

export default UnpackButton
